import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    display: "flex",
    marginRight: theme.spacing(2),
    fill: theme.palette.tableRowIcon.main,
  },
  row: {
    flex: 1,
    minHeight: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    width: "70%",
  },
  disabledBox: {
    opacity: 0.5,
    pointerEvents: "none",
  },
  label: {
    flex: "0 0 260px",
    color: theme.palette.tableRowTitle.main,
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
  },
  value: {
    flex: 2,
    fontWeight: 400,
  },
  divider: {
    flexShrink: "unset",
    width: "100%",
    backgroundColor: "transparent",
    boxShadow: "0 1px 0 0 rgba(130,130,130,0.3)",
  },
  actionPanel: {
    width: theme.spacing(6),
  },
  overflowHidden: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  infoIcon: {
    width: 16,
    height: 16,
    color: grey[500],
    marginLeft: theme.spacing(0.5),
  },
}));

export default useStyles;
